/**
 * Feature flags, sourced from `VITE_FEATURE_*` env vars.
 *
 * Usage: `if (features.wordManualAdd) { ... }` or `{features.wordManualAdd && <Button/>}`.
 *
 * Default is `false` — an unset env var hides the feature. Flip by setting
 * `VITE_FEATURE_WORD_MANUAL_ADD=true` in `.env` (or the deployment's env).
 */
function flag(value: string | undefined): boolean {
  return value === "true" || value === "1";
}

export const features = {
  wordManualAdd: flag(import.meta.env.VITE_FEATURE_WORD_MANUAL_ADD),
  wordDelete: flag(import.meta.env.VITE_FEATURE_WORD_DELETE),
  grammarSection: true,
  // Skills / Scenarios mode. Off until the content and pedagogy pass are
  // ready to ship; flip with VITE_FEATURE_SKILLS=true. Gating lives at four
  // surfaces: the /skills routes (App.tsx), the Home body dispatch
  // (Home.tsx), and the two study-mode switchers (ModeSwitch3, Settings).
  skillsEnabled: flag(import.meta.env.VITE_FEATURE_SKILLS),
} as const;

export type FeatureFlag = keyof typeof features;
